const getPageType = () => {
  const page = window.location.pathname.split('/')[1];

  if (page === 'collection') {
    return 'COLLECTION';
  }

  if (page === 'p') {
    return 'PIP';
  }

  return '';
};

export const buildServicesLink = ({ itemId, leadGenUrl } = {}) => {
  if (itemId && leadGenUrl) {
    return `${leadGenUrl}/form?vfrom=iframe-lead&internet_id=${itemId}&pageType=${getPageType()}#`;
  }

  return 'https://www.homedepot.com/services/c/';
};

export const buildSamLink = (modelNumber) => (
  `https://services.homedepot.com/sam/flooring-measure/?modelNumber=${modelNumber}&leadSource=PIP_CARPET_SAMPLES`

);
